import {createEntityService} from 'utils/createEntityService';
import {UserJobRole} from 'types/userJobRole';

export const UserJobRoleService = createEntityService<UserJobRole>({
  baseUrl: 'api/v1/user_job_roles',
  entityName: 'userJobRole',
});
